import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Shepherd from 'shepherd.js';
import { SharedService } from './shared.service';
import { ShepheredTourConst, tenantType } from 'shared/constant';

@Injectable({
  providedIn: 'root'
})
export class ShepherdTourService {

  tenantTypeId = localStorage['tenantTypeId'];
  tenantType = tenantType;

 constructor(private sharedService: SharedService, private router: Router) {}

 public setupTour(quickTour, allowUser, featureName) {
  var cookieValue = JSON.parse(this.sharedService.getCookie("ag_new_feature_tour"));

  if(featureName == null){
    this.sharedService.setCookie("ag_new_feature_tour", null , 365);
    return;
  }

  if(!allowUser || (cookieValue != null && cookieValue?.userId == localStorage['userId'] && cookieValue?.featureName == featureName && !quickTour)){
    return;
  }

  const config = {
    userId: localStorage['userId'],
    featureName: featureName,
  }

  this.sharedService.setCookie("ag_new_feature_tour", JSON.stringify(config) , 365);

  if(featureName == ShepheredTourConst.OnboardingUser){
    this.onboardingUserTour()
  }
  else if(featureName == ShepheredTourConst.AgencyOnboardingUser){
    this.agencyOnboardingUserTour()
  }
  else if(featureName == ShepheredTourConst.EandOAdmin){
    this.adminTour()
  }
}

 public onboardingUserTour() {

    // Define a new tour
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        scrollTo: true
      }
    });

    tour.addStep({
      title: "<img alt='assign-documents' src='assets/images/tour-guide/assign-documents.svg'> Complete Assigned Documents",
      text: 'Complete all assigned documents required for <br> the onboarding process. If needed, you may <br> also upload additional supporting documents.',
      attachTo: {element: '.onboarding-dashboard-step1', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        { 
          text: 'Next (1 of 5)',
          action: tour.next,
        }
      ]
    });

    tour.addStep({
      title: "<img alt='background-question' src='assets/images/tour-guide/background-question.svg'> Answer Background Questions",
      text: 'Complete background questions for both <br> new and renewal license applications.',
      attachTo: {element: '.onboarding-dashboard-step2', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        {
          classes: 'shepherd-button-secondary',
          text: 'Prev',
          action: tour.back,
        },
        { 
          text: 'Next (2 of 5)',
          action: tour.next,
        }
      ]
    });

    tour.addStep({
      title: "<img alt='employment-history' src='assets/images/tour-guide/employment-history.svg'> Complete Employment History",
      text: 'Complete your employment history for the  <br> past five years.',
      attachTo: {element: '.onboarding-dashboard-step3', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        {
          classes: 'shepherd-button-secondary',
          text: 'Prev',
          action: tour.back,
        },
        { 
          text: 'Next (3 of 5)',
          action: tour.next,
        }
      ]
    });

    // tour.addStep({
    //   title: "<img alt='signature' src='assets/images/tour-guide/signature.svg'> Add Your Signature",
    //   text: 'Your signature will be automatically fetched <br> for quick-fill documents.',
    //   attachTo: {element: '.onboarding-dashboard-step4', on: 'bottom'},
    //   buttons: [
    //     {
    //       classes: 'shepherd-button-left',
    //       text: 'Skip',
    //       action: tour.cancel,
    //     },
    //     {
    //       classes: 'shepherd-button-secondary',
    //       text: 'Prev',
    //       action: tour.back,
    //     },
    //     { 
    //       text: 'Next (4 of 5)',
    //       action: tour.next,
    //     }
    //   ]
    // });

    tour.addStep({
      title: "<img alt='chat' src='assets/images/tour-guide/chat.svg'> Chat with your hiring manager",
      text: 'If you have any questions throughout the <br> onboarding process, please contact your <br> Hiring Manager for assistance.',
      attachTo: {element: '.onboarding-dashboard-step5', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        {
          classes: 'shepherd-button-secondary',
          text: 'Prev',
          action: tour.back,
        },
        { 
          text: 'Next (4 of 5)',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      title: "<img alt='chat' src='assets/images/tour-guide/ic-checklist.svg'> Ready for Review ",
      text: "When you've finished uploading the required  <br> documents and completing all required information, <br> click Ready for Review to notify your hiring manager <br> that your submission is ready for review.",
      attachTo: {element: '.onboarding-dashboard-step6', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        {
          classes: 'shepherd-button-secondary',
          text: 'Prev',
          action: tour.back,
        },
        { 
          text: 'Done',
          action: tour.complete
        }
      ]
    });

    // Start the tour
    this.startTour(tour);
  }

  public agencyOnboardingUserTour() {

    // Define a new tour
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        scrollTo: true
      }
    });

    tour.addStep({
      title: "<img alt='assign-documents' src='assets/images/tour-guide/assign-documents.svg'> Complete Assigned Documents",
      text: 'Complete all assigned documents required for <br> the onboarding process. If needed, you may <br> also upload additional supporting documents.',
      attachTo: {element: '.onboarding-dashboard-step1', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        { 
          text: 'Next (1 of 4)',
          action: tour.next,
        }
      ]
    });

    tour.addStep({
      title: "<img alt='background-question' src='assets/images/tour-guide/background-question.svg'> Answer Background Questions",
      text: 'Complete background questions for both <br> new and renewal license applications.',
      attachTo: {element: '.onboarding-dashboard-step2', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        {
          classes: 'shepherd-button-secondary',
          text: 'Prev',
          action: tour.back,
        },
        { 
          text: 'Next (2 of 4)',
          action: tour.next,
        }
      ]
    });

    tour.addStep({
      title: "<img alt='chat' src='assets/images/tour-guide/chat.svg'> Chat with your hiring manager",
      text: 'If you have any questions throughout the <br> onboarding process, please contact your <br> Hiring Manager for assistance.',
      attachTo: {element: '.onboarding-dashboard-step5', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        {
          classes: 'shepherd-button-secondary',
          text: 'Prev',
          action: tour.back,
        },
        { 
          text: 'Next (3 of 4)',
          action: tour.next
        }
      ]
    });

    tour.addStep({
      title: "<img alt='chat' src='assets/images/tour-guide/ic-checklist.svg'> Ready for Review ",
      text: "When you've finished uploading the required  <br> documents and completing all required information, <br> click Ready for Review to notify your hiring manager <br> that your submission is ready for review.",
      attachTo: {element: '.onboarding-dashboard-step6', on: 'bottom'},
      buttons: [
        {
          classes: 'shepherd-button-left',
          text: 'Skip',
          action: tour.cancel,
        },
        {
          classes: 'shepherd-button-secondary',
          text: 'Prev',
          action: tour.back,
        },
        { 
          text: 'Done',
          action: tour.complete
        }
      ]
    });

    // Start the tour
    this.startTour(tour);
  }

  public adminTour() {

    var that = this
    // Define a new tour
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        scrollTo: true
      }
    });

    tour.addStep({
      title: "<span style='padding: 8px;background: #f0f6fd;border-radius: 8px;display: flex;'><img alt='assign-documents' src='assets/images/ic-error-omissions.svg'></span> Errors & Omissions and Bonds Is Now Available  🎉",
      text: `You can now include your Errors and Omissions (E&O) and Bonds policies for both your firm and individual <br> team members. It's important to regularly monitor these policies as part of your risk <br> management strategy. Staying organized is key to managing risks effectively. <p class='subtitle'> Additionally, you can add E&O and Bonds information directly from the ${tenantType[this.tenantTypeId]} listing page.</p>`,
      attachTo: {element: '.current-tour', on: 'right'},
      buttons: [
        {
          classes: 'shepherd-button-secondary',
          text: 'Not Now',
          action: tour.cancel,
        },
        { 
          text: 'Let’s Go!',
          action: function()
          {
            that.router.navigate(['errors-omissions'])
          // window.location.href='/onboarding';
          tour.next()
          }
        }
      ]
    });

    // Start the tour
    this.startTour(tour);
  }

  private startTour(tour: Shepherd.Tour) {
    tour.start();
  }
}
